<template>
    <div>
        <datatable-filter v-show="datatable.filterStatus"
                          @filter="filter"
                          @filterClear="filterClear"
                          :export-excel="checkPermission('studentclubstudent_presidentstudentlistexcelexport')"
                          @exportExcel="downloadExcel">
            <b-row>
                <b-col sm="12" md="4">
                    <b-form-group :label="$t('student_number')">
                        <b-form-input size="sm" v-model="datatable.queryParams.filter.student_number"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group :label="$t('name')">
                        <b-form-input size="sm" v-model="datatable.queryParams.filter.name"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group :label="$t('surname')">
                        <b-form-input size="sm" v-model="datatable.queryParams.filter.surname"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
        </datatable-filter>

        <datatable :isLoading.sync="datatable.isLoading"
                   :columns="datatable.columns"
                   :rows="datatable.rows"
                   :total="datatable.total"
                   :queryParams="datatable.queryParams"
                   :lineNumbers="false"
                   @on-page-change="onPageChange"
                   @on-sort-change="onSortChange"
                   @on-per-page-change="onPerPageChange"
                   v-show="datatable.showTable"
        />
    </div>
</template>

<script>
    //Component
    import DatatableFilter from '@/components/datatable/DatatableFilter'
    import Datatable from '@/components/datatable/Datatable'
    import CommonModal from "@/components/elements/CommonModal"

    //Other
    import qs from "qs"

    //Service
    import StudentClubService from "@/services/StudentClubService"

    //Pages

    export default {
        props: {
            clubData: {
                type: Object,
            }
        },

        components: {
            DatatableFilter,
            Datatable,
            CommonModal,
        },

        data() {
            return {
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: this.toUpperCase('student_number'),
                            field: 'student_number',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('name'),
                            field: "name",
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('surname'),
                            field: 'surname',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('club_name'),
                            field: 'role',
                            hidden: false,
                            formatFn: () => {
                                return this.clubData.student_club.name
                            }
                        },
                        {
                            label: this.toUpperCase('status'),
                            field: 'status',
                            hidden: false,
                            formatFn: (row) => {
                                if (row === 'active') {
                                    return this.$t('active');
                                } else if (row === 'passive') {
                                    return this.$t('passive');
                                } else if (row === 'waiting_payment') {
                                    return this.$t('waiting_payment');
                                } else {
                                    return '';
                                }
                            },
                        },
                        {
                            label: this.toUpperCase('role'),
                            field: this.getLocaleField('role_name'),
                            hidden: false,
                        },
                        {
                            label: this.toUpperCase('member_at'),
                            field: 'membership_date',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('gsm_no'),
                            field: 'mobile_tel',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('email'),
                            field: 'email',
                            hidden: false
                        },
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: 'id',
                        page: 1,
                        limit: 20
                    }
                },
                formId: null,
                form: {},
                formProcess: null
            }
        },

        methods: {
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                return StudentClubService.presidentsClubMemberList(config, this.clubData.student_club_id).then(response => {
                    this.datatable.rows = response.data.data;
                    this.datatable.total = response.data.pagination.total;
                }).finally(() => {
                    this.datatable.isLoading = false;
                });
            },

            downloadExcel(){
                const config = {
                    params: {
                        filter: {
                            limit: -1
                        },
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                StudentClubService.downloadAsExcelPresidentStudentList(config, this.clubData.student_club_id).then(response => {
                    this._downloadFile(response, this.$t('student_list') + '.xlsx')
                }).catch(err => this.showErrors(err, null))
            }

        },

        created() {

        },

    }
</script>
